<script setup>
import { onBeforeUnmount, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useModalStore } from '@/store/modalStore'

const modalStore = useModalStore()
const route = useRoute()
const operationBusy = ref(false)
watch(
  () => modalStore.component,
  () => {
    operationBusy.value = false
  },
  { flush: 'sync' }
)

watch(
  () => route.fullPath,
  () => {
    if (modalStore.isOpen) {
      modalStore.closeModal(false)
    }
  },
  { flush: 'sync' }
)

onBeforeUnmount(() => {
  if (modalStore.isOpen) {
    modalStore.closeModal(false)
  }
})
</script>

<template>
  <v-dialog
    :model-value="modalStore.isOpen"
    :max-width="modalStore.maxWidth"
    :persistent="modalStore.persistent || operationBusy"
    scrollable
    @update:model-value="!$event && !operationBusy && modalStore.dismissModal()"
  >
    <component
      :is="modalStore.component"
      v-if="modalStore.component"
      v-bind="modalStore.props"
      class="mx-auto w-100"
      @close-modal="modalStore.closeModal"
      @busy-change="operationBusy = $event"
    />
  </v-dialog>
</template>
